import React from 'react';

import { LoadingButtonProps } from '@mui/lab';

import { StyledButton } from './index.styles';

export interface ButtonProps extends LoadingButtonProps {
  /**
   * If `true`, the button text is all caps
   */
  allCaps?: boolean;
  rounded?: boolean;
  /**
   * Ref for the inner button component
   */
  buttonRef?: React.RefObject<HTMLButtonElement>;
  /** Where a button given an `href`, which draws as a link, opens it. */
  target?: React.AnchorHTMLAttributes<HTMLAnchorElement>['target'];
  rel?: React.AnchorHTMLAttributes<HTMLAnchorElement>['rel'];
}

const Button = ({
  buttonRef,
  rounded = true,
  variant = 'outlined',
  size = 'medium',
  allCaps = false,
  color = 'primary',
  children,
  ...rest
}: ButtonProps) => (
  <StyledButton
    ref={buttonRef}
    variant={variant}
    color={color}
    size={size}
    disableElevation
    $allCaps={allCaps}
    $rounded={rounded}
    {...rest}
  >
    {children}
  </StyledButton>
);

export default Button;
